import React from 'react';
import { useUIColors } from '../../hooks/useTheme';

const RequestListViewTabs = ({ tabs = [], activeKey, onChange, isDarkMode = false, ariaLabel = 'Vistas de solicitudes' }) => {
  const ui = useUIColors();

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 4,
        padding: '0 12px',
        borderBottom: `1px solid ${ui.border}`,
        background: ui.header,
        overflowX: 'auto',
      }}
    >
      {tabs.map((item) => {
        const active = activeKey === item.key;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.key)}
            style={{
              appearance: 'none',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              padding: '10px 12px',
              marginBottom: -1,
              fontSize: 13,
              fontWeight: active ? 700 : 500,
              color: active ? ui.text : ui.muted,
              borderBottom: active ? '2px solid #16a34a' : '2px solid transparent',
              whiteSpace: 'nowrap',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span>{item.label}</span>
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: active ? (isDarkMode ? '#86efac' : '#15803d') : ui.muted,
                background: active
                  ? isDarkMode
                    ? 'rgba(22, 163, 74, 0.2)'
                    : 'rgba(22, 163, 74, 0.12)'
                  : isDarkMode
                    ? 'rgba(255,255,255,0.06)'
                    : 'rgba(0,0,0,0.05)',
                borderRadius: 999,
                padding: '1px 7px',
                minWidth: 18,
                textAlign: 'center',
              }}
            >
              {item.count ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default RequestListViewTabs;
